import { translate as t } from '@thoughtspot/i18n';
import _ from 'lodash';
export var ValidationErrorKey;
(function (ValidationErrorKey) {
    ValidationErrorKey[ValidationErrorKey["NAME"] = 0] = "NAME";
    ValidationErrorKey[ValidationErrorKey["SOURCE_URL"] = 1] = "SOURCE_URL";
    ValidationErrorKey[ValidationErrorKey["ICON_URL"] = 2] = "ICON_URL";
    ValidationErrorKey[ValidationErrorKey["CHART_APP_ACCESS_TOKEN"] = 3] = "CHART_APP_ACCESS_TOKEN";
})(ValidationErrorKey || (ValidationErrorKey = {}));
const MAX_CHART_APP_ACCESS_TOKEN_LENGTH = 120;
const HTTP_REGEX_STRING = '^(https:\\/\\/)' +
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
    '((\\d{1,3}\\.){3}\\d{1,3}))' +
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
    '(\\?[;&a-z\\d%_.~+=-]*)?' +
    '(\\#[-a-z\\d_]*)?$';
function validURL(str) {
    const pattern = new RegExp(HTTP_REGEX_STRING, 'i');
    return pattern.test(str);
}
function validAccessToken(str) {
    return str.length <= MAX_CHART_APP_ACCESS_TOKEN_LENGTH;
}
export const validateCustomChart = (customChart) => {
    const errorMap = {};
    if (_.isNil(customChart.name) || _.isEmpty(customChart.name.trim())) {
        errorMap[ValidationErrorKey.NAME] = t('customChart.form.validationError.requiredField');
    }
    if (!_.isNil(customChart.chartAppAccessToken) &&
        !validAccessToken(customChart.chartAppAccessToken)) {
        errorMap[ValidationErrorKey.CHART_APP_ACCESS_TOKEN] = t('customChart.form.validationError.invalidChartAppAccessToken');
    }
    if (_.isNil(customChart.sourceUrl) ||
        _.isEmpty(customChart.sourceUrl.trim())) {
        errorMap[ValidationErrorKey.SOURCE_URL] = t('customChart.form.validationError.requiredField');
    }
    else if (!validURL(customChart.sourceUrl)) {
        errorMap[ValidationErrorKey.SOURCE_URL] = t('customChart.form.validationError.invalidUrl');
    }
    if (!_.isNil(customChart.iconUrl) &&
        !_.isEmpty(customChart.iconUrl) &&
        !validURL(customChart.iconUrl)) {
        errorMap[ValidationErrorKey.ICON_URL] = t('customChart.form.validationError.invalidUrl');
    }
    return errorMap;
};
export const testHooks = { validURL, validAccessToken };
//# sourceMappingURL=custom-chart.util.js.map